export default function getQueryParam({ location }) {
    return location.search.split('?')[1];
}
